import { defineStore, acceptHMRUpdate } from 'pinia'
import api from "../services/api.js";

export const useMonitorStore = defineStore('monitor', {
    state: () => ({
        _home_stats: null,
        _orders_stats: null,
    }),

    getters: {
        home_stats: (state) => state._home_stats,
        order_stats: (state) => state._orders_stats
    },

    actions: {
        async getHomeStats() {
            const resp = await api.get('/monitoring')
            this._home_stats = resp.data
        },
        async getOrdersStats() {
            const resp = await api.get('/monitoring/orders')
            this._orders_stats = resp.data
        }
    }
})

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useMonitorStore, import.meta.hot))
}

